import { createStore, applyMiddleware } from "redux"
import thunk from "redux-thunk"
import promiseMiddleware from "redux-promise-middleware"
import { composeWithDevTools } from "redux-devtools-extension"
import { persistStore, autoRehydrate } from "redux-persist"
import { REHYDRATE } from "redux-persist/constants"
import createActionBuffer from "redux-action-buffer"
import { createEpicMiddleware } from "redux-observable"
import { routerMiddleware } from "react-router-redux"
import { createBrowserHistory } from "history"

import rootReducer from "../reducers/root-reducer"
import rootEpic from "../epics/root-epic"

export const history = createBrowserHistory()

const epicMiddleware = createEpicMiddleware(rootEpic)
const actionBufferMiddleware = createActionBuffer(REHYDRATE)
const reactRouterMiddleware = routerMiddleware(history)

export const store = createStore(
    rootReducer,
    undefined,
    composeWithDevTools(
        applyMiddleware(
            epicMiddleware,
            actionBufferMiddleware,
            reactRouterMiddleware,
            thunk,
            promiseMiddleware()
        ),
        autoRehydrate()
    )
)

const persistenceConfig = {
    whitelist: ["authentication"],
}
persistStore(store, persistenceConfig)
